module.exports = __webpack_public_path__ + "static/media/135_Front.c610bb2c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/GalleryPhotos/135_Front.jpg
// module id = 531
// module chunks = 0